export default "__VITE_ASSET__0774795f__"